<template>
  <div class="app-container">
    <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="68px">
      <el-form-item label="检查任务" prop="taskId">
        <el-input
          v-model="queryParams.taskId"
          placeholder="请选择检查任务"
          clearable
          @keyup.enter.native="handleQuery"/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table
        :data="itemList"
        :header-cell-style="{ background: 'rgb(250,250,250)' }"
        style="width: 100%">
      <el-table-column type="selection" width="55" align="center"/>
      <el-table-column label="检查序号" align="center" prop="checkName"/>
      <el-table-column label="适用场合" align="center" prop="applicablePlace"/>
      <el-table-column label="检查依据" align="center" prop="checkBasis" />
      <el-table-column label="检查内容" align="center" prop="checkContent" />
      <el-table-column label="检查方式" align="center" prop="checkWay"/>
      <el-table-column label="创建时间" align="center" prop="createTime"/>
      <el-table-column label="创建人" align="center" prop="creator"/>
      <el-table-column label="记录状态" align="center" prop="deleted">
        <template slot-scope="{ row }">
          {{ row.deleted == 0 ? '正常' : '已删除' }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button
              size="mini"
              type="text"
              icon="el-icon-edit"
              @click="handleCheckscore(scope.row)">查看评分细则
          </el-button>
        </template>
      </el-table-column>
    </el-table>


    <!-- 添加或修改检查项对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="500px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="检查任务" prop="taskId">
          <el-input v-model="form.taskId" placeholder="请输入检查任务" />
        </el-form-item>
        <el-form-item label="检查序号" prop="checkName">
          <el-input v-model="form.checkName" placeholder="请输入检查序号" />
        </el-form-item>
        <el-form-item label="检查内容" prop="checkConteNt">
          <el-input v-model="form.checkConteNt" type="textarea" placeholder="请输入内容" />
        </el-form-item>
        <el-form-item label="检查方式" prop="checkWay">
          <el-input v-model="form.checkWay" type="textarea" placeholder="请输入内容" />
        </el-form-item>
        <el-form-item label="检查依据" prop="checkBasis">
          <el-input v-model="form.checkBasis" type="textarea" placeholder="请输入内容" />
        </el-form-item>
        <el-form-item label="适用场合" prop="applicablePlace">
          <el-input v-model="form.applicablePlace" type="textarea" placeholder="请输入内容" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listItem, getItem, delItem, addItem, updateItem } from "@/api/specialExamination/item";

export default {
  name: "Item",
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      curPage: 1,
      pageSize: 10,
      // 检查项表格数据
      itemList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        taskId: null,
        checkName: null,
        checkConteNt: null,
        checkWay: null,
        checkBasis: null,
        applicablePlace: null,
        delete: null,
        createDate: null,
        updateDate: null,
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
      }
    };
  },
  created(val) {
    this.curPage = val;
    this.getList();
  },
  methods: {
    /** 查询检查项列表 */
    getList() {
      this.loading = true;
      listItem({limit: this.pageSize, curPage: this.curPage, type: 0, isPage: 1}).then(response => {
        this.itemList = response.body.data;
        this.total = response.body.cum
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        taskId: null,
        checkName: null,
        checkConteNt: null,
        checkWay: null,
        checkBasis: null,
        applicablePlace: null,
        delete: null,
        createDate: null,
        createBy: null,
        updateDate: null,
        updateBy: null
      };

    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.handleQuery();
    },

    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加检查项";
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const id = row.id
      getItem(id).then(response => {
        this.form = response.body.data;
        this.open = true;
        this.title = "修改检查项";
      });
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.id != null) {
            updateItem(this.form).then(response => {
              this.open = false;
              this.getList();
            });
          } else {
            addItem(this.form).then(response => {
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      delItem(row.id).then(res => {
        this.$message.success('删除成功')
        this.getList()
      })
    },
  }
};
</script>
